import { createAction, createReducer } from '@reduxjs/toolkit';
import { Recording } from '../../types/rest/assetCatalogTypes';
import { RecordingsState } from './recordingsTypes';
import { SortConfiguration } from '../../types/rest/paginationTypes';
import { initPageable } from '../transactions/transactionsReducer';
import { PageFilterContent } from '../ui/pageFilters/pageFilterTypes';
import { SelectAllType } from '../../components/blazeTable/BlazeTable.types';

const initialState: RecordingsState = {
  recordings: [],
  isLoading: false,
  isCreatingNewRecording: false,
  expandedRecordingId: null,
  sort: {} as SortConfiguration,
  pageable: initPageable,
  selectAllType: null,
  selectedRecordings: [],
  isBulkTaggerOpen: false,
  isConvertedOpened: false,
  totalRecordings: 0,
  pageFilter: {
    searchTerm: '',
    serviceId: 0,
  } as PageFilterContent,
};

interface RecordingsPage {
  recordings: Recording[];
  total: number;
  isLoading: boolean;
}

export const getRecordings = createAction<RecordingsPage>('GET_RECORDINGS');
export const setIsLoadingRecording = createAction<boolean>('SET_IS_LOADING_RECORDING');
export const setIsCreatingNewRecording = createAction<boolean>('SET_IS_CREATING_NEW_RECORDING');
export const expandRecordingRow = createAction<number | null>('EXPAND_RECORDING_ROW');
export const openRecordingBulkTagModal = createAction<boolean>('OPEN_RECORDING_BULK_TAG_MODAL');
export const openConverterModal = createAction<boolean>('OPEN_CONVERTER_TO_TRANSACTION_MODAL');
export const sortRecordings = createAction<SortConfiguration>('SORT_RECORDINGS_TABLE');
export const activeRecordingPageUpdated = createAction<number>('UPDATE_ACTIVE_PAGE_RECORDINGS');
export const changeRecordingPageSize = createAction<number>('SET_RECORDINGS_PAGE_SIZE');
export const setRecordingFilter = createAction<PageFilterContent>('SET_RECORDINGS_SEARCH_TERM');
export const setSelectedRecordings = createAction<{
  selectedIds: number[];
  selectAllType?: SelectAllType;
}>('SET_SELECTED_RECORDINGS');

export const recordingsReducer = createReducer(initialState, builder => {
  builder.addCase(setIsLoadingRecording, (state, action) => {
    state.isLoading = action.payload;
  });

  builder.addCase(getRecordings, (state, action) => {
    state.recordings = action.payload.recordings;
    state.totalRecordings = action.payload.total;
    state.isLoading = action.payload.isLoading;
  });

  builder.addCase(setIsCreatingNewRecording, (state, action) => {
    state.isCreatingNewRecording = action.payload;
  });

  builder.addCase(expandRecordingRow, (state, action) => {
    state.expandedRecordingId = action.payload;
  });

  builder.addCase(openRecordingBulkTagModal, (state, action) => {
    state.isBulkTaggerOpen = action.payload;
  });

  builder.addCase(openConverterModal, (state, action) => {
    state.isConvertedOpened = action.payload;
  });

  builder.addCase(sortRecordings, (state, action) => {
    state.sort = action.payload;
  });

  builder.addCase(activeRecordingPageUpdated, (state, action) => {
    state.pageable = { ...state.pageable, skip: action.payload };
  });

  builder.addCase(changeRecordingPageSize, (state, action) => {
    state.pageable = { ...state.pageable, limit: action.payload };
  });

  builder.addCase(setRecordingFilter, (state, action) => {
    state.pageFilter = action.payload;
  });
  builder.addCase(setSelectedRecordings, (state, action) => {
    state.selectedRecordings = action.payload.selectedIds;
    state.selectAllType = action.payload.selectAllType ? action.payload.selectAllType : null;
  });
});
